module.exports = __webpack_public_path__ + "static/img/banner001.c0c3db9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner001.jpg
// module id = UIOE
// module chunks = 15